// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

export const cleanPayload = <T extends object>(payload: T, reference: T): T => {
  if (Array.isArray(payload)) {
    // Ensure reference is an array before accessing [0]
    if (Array.isArray(reference)) {
      return payload.map(item => cleanPayload(item, reference[0] ?? {})) as T;
    }
    return payload; // If reference isn't an array, return payload as-is
  }

  if (typeof payload === 'object' && payload !== null) {
    return Object.keys(reference).reduce((acc, key) => {
      const value = payload[key as keyof T];

      if (key in payload) {
        if (Array.isArray(value)) {
          // Ensure reference[key] is an array before trying reference[key][0]
          if (Array.isArray(reference[key as keyof T])) {
            acc[key as keyof T] = value.map(item =>
              cleanPayload(item, (reference[key as keyof T] as any[])[0] ?? {}),
            ) as any;
          } else {
            acc[key as keyof T] = value as any; // Keep value if reference[key] isn't an array
          }
        } else if (typeof value === 'object' && value !== null) {
          acc[key as keyof T] = cleanPayload(
            value,
            reference[key as keyof T] as any,
          );
        } else {
          acc[key as keyof T] = value;
        }
      }
      return acc;
    }, {} as T);
  }

  return payload;
};
